var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTvWeb = function SvgTvWeb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66797 4.58333H18.3346V14.6667H3.66797V4.58333ZM1.83464 4.58333C1.83464 3.57081 2.65545 2.75 3.66797 2.75H18.3346C19.3472 2.75 20.168 3.57081 20.168 4.58333V14.6667C20.168 15.6792 19.3472 16.5 18.3346 16.5H3.66797C2.65545 16.5 1.83464 15.6792 1.83464 14.6667V4.58333ZM1.83464 17.4167C1.32837 17.4167 0.917969 17.8271 0.917969 18.3333C0.917969 18.8396 1.32837 19.25 1.83464 19.25H20.168C20.6742 19.25 21.0846 18.8396 21.0846 18.3333C21.0846 17.8271 20.6742 17.4167 20.168 17.4167H1.83464Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3777 8.9341C13.8741 9.22772 13.8741 10.0224 13.3777 10.3161L9.27678 12.7415C8.81088 13.0171 8.25 12.6396 8.25 12.0506V7.1996C8.25 6.61052 8.81088 6.23307 9.27678 6.50862L13.3777 8.9341Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTvWeb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tv_web.385d6bc2811114765634072bff60ae0b.svg";